var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row card p-3 mx-0 border border-nmidfour rounded"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"bold c-nmidone text-uppercase"},[_vm._v(" razão social ")]),_c('p',{staticClass:"medium c-ndarkthree text-uppercase"},[_vm._v(" "+_vm._s(_vm.name)+". ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }